import React from 'react';
import './help-dialog.css';
import { useNavigate } from 'react-router-dom';
import VisualProgrammingIcon from '../../../assets/visual-programming-icon.svg';
import PublishProjectRichIcon from '../../../assets/publish-project-rich-icon.svg';
import TestingLogicIcon from '../../../assets/testing-logic-icon.svg';
import NumberDataTypeBlackIcon from '../../../assets/datatype-icons/black/number.svg';
import ListDataTypeBlackIcon from '../../../assets/datatype-icons/black/list.svg';
import TextDataTypeBlackIcon from '../../../assets/datatype-icons/black/text.svg';
import BooleanDataTypeBlackIcon from '../../../assets/datatype-icons/black/boolean.svg';
import DateTimeDataTypeBlackIcon from '../../../assets/datatype-icons/black/date-time.svg';
import { EditorService } from '../../../services/editor';
import { TutorialVideoEmbed } from '../TutorialVideoEmbed';

const HelpDialogHomeContent: React.FC<{ project: EditorService }> = ({
	project
}) => {
	const navigate = useNavigate();

	const navigateTo = (path: string) => {
		navigate(path);
	};

	return (
		<div className="help-dialog-home-content">
			<h3 className="help-dialog-home-content__title">
				Need help with Elyx?
			</h3>
			<p className="help-dialog-home-content__paragraph">
				Read our help articles on specific topics
			</p>
			<p className="help-dialog-home-content__paragraph">
				Follow any <i className="fa-regular fa-question-circle" /> icons
				to their respective help articles when you see them throughout
				the app.
			</p>
			<br />

			<TutorialVideoEmbed bleedOffset={82} />

			<div className="help-dialog-bleed-separator" />

			<h4 className="help-dialog-home-content__subtitle">
				Get started with...
			</h4>

			<div className="help-dialog-home-content__quick-links-cards__container">
				<a
					className="help-dialog-home-content__quick-links-cards__card"
					href={`${project?.editorBasePath}/help/canvas-basics`}
					onClick={(e) => {
						e.preventDefault();
						navigateTo(
							`${project?.editorBasePath}/help/canvas-basics`
						);
					}}
				>
					<h5 className="help-dialog-home-content__quick-links-cards__card__title">
						Canvas basics
					</h5>
					<img
						className="help-dialog-home-content__quick-links-cards__card__icon"
						src={VisualProgrammingIcon}
					/>
				</a>

				<a
					className="help-dialog-home-content__quick-links-cards__card"
					href={`${project?.editorBasePath}/help/datatypes`}
					onClick={(e) => {
						e.preventDefault();
						navigateTo(`${project?.editorBasePath}/help/datatypes`);
					}}
				>
					<h5 className="help-dialog-home-content__quick-links-cards__card__title">
						Data types
					</h5>
					<span
						style={{
							display: 'flex',
							gap: '8px',
							marginBottom: '6px'
						}}
					>
						<img
							style={{ width: '20px', objectFit: 'contain' }}
							src={BooleanDataTypeBlackIcon}
						/>
						<img
							style={{ width: '20px', objectFit: 'contain' }}
							src={NumberDataTypeBlackIcon}
						/>
						<img
							style={{ width: '20px', objectFit: 'contain' }}
							src={TextDataTypeBlackIcon}
						/>
						<img
							style={{ width: '20px', objectFit: 'contain' }}
							src={ListDataTypeBlackIcon}
						/>
						<img
							style={{ width: '20px', objectFit: 'contain' }}
							src={DateTimeDataTypeBlackIcon}
						/>
					</span>
				</a>

				<a
					className="help-dialog-home-content__quick-links-cards__card"
					href={`${project?.editorBasePath}/help/testing-logic`}
					onClick={(e) => {
						e.preventDefault();
						navigateTo(
							`${project?.editorBasePath}/help/testing-logic`
						);
					}}
				>
					<h5 className="help-dialog-home-content__quick-links-cards__card__title">
						Testing your logic
					</h5>
					<img
						className="help-dialog-home-content__quick-links-cards__card__icon"
						src={TestingLogicIcon}
					/>
				</a>

				<a
					className="help-dialog-home-content__quick-links-cards__card"
					href={`${project?.editorBasePath}/help/project-publication`}
					onClick={(e) => {
						e.preventDefault();
						navigateTo(
							`${project?.editorBasePath}/help/project-publication`
						);
					}}
				>
					<h5 className="help-dialog-home-content__quick-links-cards__card__title">
						Publishing a project
					</h5>
					<img
						className="help-dialog-home-content__quick-links-cards__card__icon"
						src={PublishProjectRichIcon}
					/>
				</a>
			</div>

			<div className="help-dialog-bleed-separator" />

			<h4 className="help-dialog-home-content__subtitle">
				Join our Discord server
			</h4>

			<div
				className="help-dialog-home-content__quick-links-cards__container"
				style={{ marginTop: '10px' }}
			>
				<a
					className="help-dialog-home-content__quick-links-cards__card"
					href="https://discord.gg/DR2qZupRQW"
					target="_blank"
				>
					<p className="help-dialog-home-content__quick-links-cards__card__description">
						Join our Discord server
					</p>
					<img
						className="help-dialog-home-content__quick-links-cards__card__icon"
						src="https://assets-global.website-files.com/6257adef93867e50d84d30e2/636e0b5061df29d55a92d945_full_logo_blurple_RGB.svg"
					/>
				</a>
			</div>
			<div className="help-dialog-home-content__standalone-centered_paragraph_container">
				<p
					className="help-dialog-home-content__paragraph"
					style={{ maxWidth: '300px', textAlign: 'center' }}
				>
					Join our community on Discord and ask questions directly to
					our team and other Elyx users.
				</p>
			</div>
		</div>
	);
};

export default HelpDialogHomeContent;
